import { FunctionComponent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './suggestDaycare.module.scss'
import Dialog from '@/components/_custom/Dialog/Dialog'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import { useMutation } from '@apollo/client'
import { REQUEST_DAYCARE } from '@/modules/API/software/requestDaycare'
import UserInput from '@/components/_custom/UserInput/userInput'
import ButtonText from '@/components/_custom/Buttons/ButtonText/ButtonText'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'

interface suggestDaycareDialogProps {
    open: boolean
    handleClose: () => void
    parent: boolean
}

const SuggestDaycareDialog: FunctionComponent<suggestDaycareDialogProps> = ({
    open,
    handleClose,
    parent
}: suggestDaycareDialogProps) => {
    const { t } = useTranslation()

    const [submit, setSubmit] = useState<boolean>(false)

    const [daycareName, setDaycareName] = useState<string>('')
    const [daycareCity, setDaycareCity] = useState<string>('')
    const [daycareEmail, setDaycareEmail] = useState<string>('')
    const [daycareTelephone, setDaycareTelephone] = useState<string>('')

    const [requestDaycare] = useMutation(REQUEST_DAYCARE, {
        variables: {
            daycare_name: daycareName,
            daycare_address: daycareCity,
            daycare_email: daycareEmail,
            daycare_telephone: daycareTelephone
        },
        onCompleted: () => {
            setSubmit(true)
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('suggestDaycare')} parent={parent} />
            <DialogBody className={styles.DialogBody}>
                {submit ? (
                    <div className={styles.InputContainer}>
                        <p className={styles.TextInput}>{t('suggestDaycareSuccess')}</p>
                        <ButtonText onClick={handleClose} text={t('close')} parent={parent} fullWidth />
                    </div>
                ) : (
                    <div className={styles.InputContainer}>
                        <UserInput
                            label={t('daycareName')}
                            value={daycareName}
                            setValue={setDaycareName}
                            required
                            parent={parent}
                            className={styles.Input}
                            type={'text'}
                            format={'pascal'}
                        />
                        <UserInput
                            id={'city'}
                            label={t('city')}
                            value={daycareCity}
                            setValue={setDaycareCity}
                            required
                            parent={parent}
                            className={styles.Input}
                            type='text'
                            format={'pascal'}
                        />
                        <UserInput
                            id={'email'}
                            label={t('email')}
                            value={daycareEmail}
                            setValue={setDaycareEmail}
                            parent={parent}
                            className={styles.Input}
                            verify={'email'}
                            type='text'
                            unallowedCharacters={'email'}
                        />
                        <UserInput
                            id={'phone'}
                            label={t('phone')}
                            value={daycareTelephone}
                            setValue={setDaycareTelephone}
                            type='text'
                            verify={'phone'}
                            format={'phone'}
                            parent={parent}
                            className={styles.Input}
                        />
                        <div className={styles.ButtonContainer}>
                            <ButtonTextIcon
                                onClick={handleClose}
                                type={'cancel'}
                                parent={parent}
                                className={styles.Button}
                            />
                            <ButtonTextIcon
                                onClick={() => {
                                    requestDaycare()
                                }}
                                type={'confirm'}
                                parent={parent}
                                disabled={!daycareName || !daycareCity}
                                className={styles.Button}
                            />
                        </div>
                    </div>
                )}
            </DialogBody>
        </Dialog>
    )
}

export default SuggestDaycareDialog
